<template>
    <div class="flex h-full min-h-0 flex-col">
        <!-- min-h-36 matches the blue work-order header (px-8 py-4 + AssetShortInfo min-h-28) so both columns align. -->
        <header class="sticky top-0 z-10 flex min-h-36 items-center gap-3 border-b border-panel-border bg-panel px-6 py-5">
            <h2 class="text-base font-bold tracking-wide text-brand-header uppercase">{{ trans('external.board.title') }}</h2>
            <span class="rounded-full bg-white px-2.5 py-0.5 text-sm font-semibold text-gray-text">{{ totalCount }}</span>
            <button
                v-if="dismissible"
                type="button"
                class="ml-auto text-gray-text lg:hidden"
                :aria-label="trans('general.action.close')"
                @click="$emit('dismiss')"
            >
                <icon icon="cil-x" />
            </button>
        </header>

        <div class="min-h-0 flex-1 overflow-y-auto px-4 py-5">
            <external-board-empty-state v-if="totalCount === 0" />
            <div v-else class="flex flex-col gap-6">
                <external-work-order-rail-group
                    v-for="group in groups"
                    :key="group.key"
                    :status="group.key"
                    :label="group.label"
                    :items="group.items"
                    :selected-id="selectedId"
                    @select="$emit('select', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import ExternalWorkOrderRailGroup from '@/Pages/WorkOrders/ExternalWorkOrderRailGroup.vue';
import ExternalBoardEmptyState from '@/Pages/WorkOrders/ExternalBoardEmptyState.vue';
import { trans } from '@/mixins/i18n.js';

defineEmits(['select', 'dismiss']);

const props = defineProps({
    groups: {
        type: Array,
        default: () => [],
    },
    selectedId: {
        type: [String, Number, null],
        default: null,
    },
    dismissible: {
        type: Boolean,
        default: false,
    },
});

const totalCount = computed(() => props.groups.reduce((total, group) => total + group.items.length, 0));
</script>
